import { injectable } from "inversify";
import { Dispatch, SetStateAction } from "react";
import SortingItemDescriptor from "features/shared/components/sorting/models/SortingItemDescriptor";
import { ISortingStateHandler } from "./ISortingStateHandler";
import { SortingDirection } from "../models/SortingDirection";

@injectable()
export class SortingStateHandler implements ISortingStateHandler {
  
  loadSortingDescriptors(dataSortJson: string): SortingItemDescriptor[] {
    try {
      const descriptors = JSON.parse(
        dataSortJson
      ) as SortingItemDescriptor[];
  
      if (descriptors && descriptors.length > 0) {
        return descriptors;
      }
    } catch (error) {}
  
    return [];
  }

  getUrlParamsOfActiveSorting(descriptors: SortingItemDescriptor[]): string {
    let activeDesc = descriptors.find((x) => x.active);

    if (activeDesc) {
      const sortingUrlParams = new URLSearchParams({
        SortBy: activeDesc.name,
        SortDirection: activeDesc.direction!,
      });

      return sortingUrlParams.toString();
    }

    return "";
  }

  changeSorting(
    name: string,
    direction: SortingDirection,
    descriptors: SortingItemDescriptor[],
    dispatchDescriptors: Dispatch<SetStateAction<SortingItemDescriptor[]>>
  ): void {
    let newDescriptors = [...descriptors];
    let activeDesc = newDescriptors.find((x) => x.active);
    let selectedDesc = newDescriptors.find((x) => x.name === name);

    if (activeDesc) {
      activeDesc.active = false;
      activeDesc.direction = undefined;
    } 
    if (selectedDesc) {
      selectedDesc.active = true;
      selectedDesc.direction = direction;
    }

    dispatchDescriptors(newDescriptors);
  }

  changeSortingByUrlParams(
    sortingUrlSearchParams: string,
    descriptors: SortingItemDescriptor[],
    dispatchDescriptors: Dispatch<SetStateAction<SortingItemDescriptor[]>>
  ): void {
    if (sortingUrlSearchParams) {
      const sortingParamsFromStore = new URLSearchParams(sortingUrlSearchParams);
      let sortBy = sortingParamsFromStore.get("SortBy");
      let sortDirection = sortingParamsFromStore.get("SortDirection");

      if (sortBy && sortDirection) {
        this.changeSorting(sortBy, sortDirection as any, descriptors, dispatchDescriptors);
      }
    }
  }
}
